import { SharePointQueryable } from "../sharepointqueryable.js";
import { spPost } from "../operations.js";
import { body } from "@pnp/odata";
export function getValueForUICultureBinder(propName) {
    return function (cultureName) {
        return spPost(this.clone(SharePointQueryable, propName + "/getValueForUICulture"), body({ cultureName: cultureName }));
    };
}
//# sourceMappingURL=funcs.js.map